import build from './build/index'
import play from './play/index'

export default {
    build,
    play
}